// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert {\n  fill: #f00;\n  color: #f00;\n  text-align: center;\n  max-width: 147px;\n  display: block;\n  margin: auto;\n}\n.dk {\n  max-width: 350px;\n  display: block;\n  margin: auto;\n}", ""]);
// Exports
module.exports = exports;
